import "react";
import { styled as e } from "styled-components";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-avatar";
//#region src/components/Avatar/Avatar.tsx
var i = {
	xs: "24px",
	sm: "32px",
	md: "40px",
	lg: "56px",
	xl: "80px"
}, a = {
	xs: "10px",
	sm: "12px",
	md: "16px",
	lg: "20px",
	xl: "28px"
}, o = {
	online: "#22c55e",
	offline: "#94a3b8",
	busy: "#ef4444",
	away: "#f59e0b"
}, s = e.div`
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    width: ${({ $size: e }) => i[e]};
    height: ${({ $size: e }) => i[e]};
`, c = e(r.Root)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size: e }) => i[e]};
    height: ${({ $size: e }) => i[e]};
    border-radius: ${({ $shape: e }) => e === "circle" ? "50%" : "8px"};
    overflow: hidden;
    background-color: ${({ theme: e }) => e.colors.muted};
    border: 2px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
`, l = e(r.Image)`
    width: 100%;
    height: 100%;
    object-fit: cover;
`, u = e(r.Fallback)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ $size: e }) => a[e]};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    background-color: ${({ theme: e }) => e.colors.secondary};
    text-transform: uppercase;
`, d = e.span`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ $status: e }) => o[e]};
    border: 2px solid ${({ theme: e }) => e.colors.background};
`, f = ({ src: e, alt: r = "", fallback: i, icon: a, size: o = "md", shape: f = "circle", className: p, status: m }) => {
	let h = i ? i.split(" ").map((e) => e[0]).join("").slice(0, 2) : r.split(" ").map((e) => e[0]).join("").slice(0, 2);
	return /* @__PURE__ */ n(s, {
		$size: o,
		className: p,
		children: [/* @__PURE__ */ n(c, {
			$size: o,
			$shape: f,
			children: [e && /* @__PURE__ */ t(l, {
				src: e,
				alt: r
			}), /* @__PURE__ */ t(u, {
				$size: o,
				delayMs: 0,
				children: a ?? (h || "?")
			})]
		}), m && /* @__PURE__ */ t(d, {
			$status: m,
			$shape: f
		})]
	});
};
//#endregion
export { f as Avatar };
